<template>
  <v-dialog :model-value="dialog" width="auto" persistent="">
    <v-card width="800px" class="outlined-card">
      <div
        class="px-4 align-center py-4 bg-primary d-flex justify-space-between"
      >
        <h3>Generate insights</h3>
        <v-btn
          @click="$emit('close')"
          icon="mdi-close"
          density="compact"
          variant="text"
        ></v-btn>
      </div>
      <v-divider></v-divider>

      <v-window v-model="window" style="max-height: 600px; overflow: auto">
        <v-window-item :key="99" :value="99">
          <div
            style="height: 300px"
            class="d-flex flex-column align-center justify-center"
          >
            <p style="font-size: 9pt; margin-bottom: 5px">
              Generating insights...
            </p>
            <v-progress-linear
              round
              style="width: 100px"
              indeterminate=""
            ></v-progress-linear>
          </div>
        </v-window-item>
        <v-window-item :key="1" :value="1">
          <div class="pa-6">
            <div class="mb-2 d-flex" style="gap: 10px">
              <v-text-field
                type="number"
                :label="`Amount of insights`"
                v-model.number="n"
                variant="solo"
                flat
                bg-color="smoke"
                hide-details=""
                style="max-width: 200px"
              ></v-text-field>
              <v-text-field
                label="Language"
                v-model="language"
                variant="solo"
                flat
                bg-color="smoke"
                hide-details=""
                style="max-width: 200px"
              ></v-text-field>
            </div>
            <v-textarea
              hide-details=""
              v-model="suggestions"
              label="Suggestions for chapters"
              :placeholder="`- Chapter one\n- Chapter two`"
              variant="solo"
              flat
              bg-color="smoke"
              class="mb-2"
            ></v-textarea>
            <!-- <v-textarea
              v-model="instructions"
              hide-details=""
              label="Additional instructions"
              variant="solo"
              flat
              bg-color="smoke"
            ></v-textarea> -->
          </div>
        </v-window-item>
        <v-window-item :key="2" :value="2">
          <div class="pa-6">
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(i, index) in generated_insights"
                :key="index"
              >
                <v-expansion-panel-title style="font-size: 12pt">
                  <v-checkbox
                    class="mr-4"
                    @click.stop
                    hide-details
                    v-model="i.selected"
                  ></v-checkbox>
                  <span
                    v-if="i.topic"
                    class="text-medium-emphasis mr-3"
                    style="
                      font-size: 11px;
                      text-transform: uppercase;
                      letter-spacing: 0.06em;
                    "
                    >{{ i.topic }}</span
                  >
                  {{ i.title }}
                </v-expansion-panel-title>
                <v-expansion-panel-text class="pa-4">
                  <div
                    style="
                      display: grid;
                      grid-template-columns: 1fr 1fr;
                      gap: 35px;
                    "
                  >
                    <div>
                      <h4 class="mb-3">Findings:</h4>
                      <ul>
                        <li v-for="(f, i) in i.findings" :key="i">{{ f }}</li>
                      </ul>
                    </div>
                    <div>
                      <h4 class="mb-3">Quotes:</h4>
                      <ul>
                        <li v-for="(s, i) in i.quotes" :key="i">
                          {{ s }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>
      <template v-slot:actions>
        <div class="d-flex justify-space-between" style="width: 100%">
          <v-btn
            @click="selectAll"
            style="text-transform: none"
            v-if="window > 1 && generated_insights.length > 0"
            >Select all</v-btn
          >
          <v-spacer></v-spacer>
          <div>
            <v-btn v-if="window > 1" @click="window = window - 1"
              ><v-icon>mdi-arrow-left</v-icon></v-btn
            >
            <v-btn v-if="window === 1" @click="requestChapters">GO</v-btn>
            <v-btn
              v-if="window === 2"
              class="ms-auto"
              text="Use"
              style="text-transform: none"
              @click="useSelectedInsights"
            ></v-btn>
          </div>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { mapState } from "vuex";

export default {
  props: ["dialog", "type", "chapters"],
  computed: {
    ...mapState({
      projects: (state) => state.projects,
      project: (state) => state.project,
    }),
  },
  data() {
    return {
      headers: [
        { title: "Input", align: "start", key: "input" },
        { title: "Type", align: "start", key: "type" },
        { title: "Context", align: "start", key: "context" },
        { title: "Time", align: "start", key: "timestamp" },
      ],
      generated_insights: [],
      language: "Dutch",
      suggestions: "",
      instructions: "",
      n: 10,
      window: 1,
    };
  },
  methods: {
    selectAll() {
      this.generated_insights.forEach((i) => (i.selected = true));
    },
    setSuggestions(v) {
      this.suggestions = v;
    },
    async requestChapters() {
      this.window = 99;
      console.log("Generating chapters");
      const generateChapters = httpsCallable(functions, "generateChapters");
      const res = await generateChapters({
        project_uid: this.project.uid,
        obslog_uid: this.project.obslogs[0].uid,
        instructions: this.instructions,
        suggestions: this.suggestions,
        n: this.n,
        language: this.language,
      });
      this.window = 2;
      this.generated_insights = res.data.insights;

      console.log(res.data);
    },
    async useSelectedInsights() {
      let insights = this.generated_insights.filter((i) => i.selected);

      this.$emit("use", insights);
      this.window = 1;
      this.generated_insights = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.outlined-card {
  border-left: 1px solid black;
  border-top: 1px solid black;
  border-right: 3px solid black;
  border-bottom: 3px solid black;
}
</style>
